"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TronLinkConnector = void 0;
const utils_1 = require("@unifiprotocol/utils");
const Errors_1 = require("../../../../Errors");
const Adapters_1 = require("../../../../Adapters");
const Types_1 = require("../../../../Types");
const BaseConnector_1 = require("../../../../Connectors/BaseConnector");
const RejectedByUser_1 = require("../../../../Errors/RejectedByUser");
const TronAdapter_1 = require("../../Adapters/TronAdapter");
const TronChainIds_1 = require("../../TronChainIds");
const Utils_1 = require("../../../../Connectors/Utils");
var TronLinkCodes;
(function (TronLinkCodes) {
    TronLinkCodes[TronLinkCodes["RejectedByUser"] = 4001] = "RejectedByUser";
    TronLinkCodes[TronLinkCodes["Success"] = 200] = "Success";
})(TronLinkCodes || (TronLinkCodes = {}));
class TronLinkConnector extends BaseConnector_1.BaseConnector {
    constructor(config) {
        super({
            name: Types_1.WalletConnectors.TronLink,
            displayName: "TronLink",
            isWallet: true,
        }, config);
    }
    async _connect() {
        const agent = this.getAgent();
        if (!(await this.isAvailable())) {
            throw new Errors_1.WalletNotDetectedError(this.metadata.name);
        }
        const { code } = await agent.request({ method: "tron_requestAccounts" });
        if (!code) {
            throw new Errors_1.WalletIsLockedError(this.metadata.name);
        }
        if (code === TronLinkCodes.RejectedByUser) {
            throw new RejectedByUser_1.RejectedByUser();
        }
        if (code !== TronLinkCodes.Success) {
            throw new Error("Error connecting");
        }
        const address = await this.getAddress();
        const chainIdStr = TronChainIds_1.TronChainId.Mainnet;
        const adapter = new TronAdapter_1.TronAdapter(this.config);
        adapter.setAddress(address);
        adapter.setProvider(window.tronWeb);
        this.overrideTronLinkJsonNode(adapter.getProvider());
        const multicall = new Adapters_1.MulticallBaseAdapter(adapter);
        this.initEventController(adapter);
        const isValidNetwork = await adapter.isValidNetwork(chainIdStr);
        if (!isValidNetwork) {
            throw new Errors_1.InvalidNetworkError(chainIdStr);
        }
        return { adapter, multicall };
    }
    async isAvailable() {
        return !!this.getAgent();
    }
    getAgent() {
        return window.tronLink;
    }
    getAddress() {
        return new Promise((resolve) => {
            const obj = setInterval(async () => {
                if (window.tronWeb && window.tronWeb.defaultAddress.base58) {
                    resolve(window.tronWeb.defaultAddress.base58);
                    clearInterval(obj);
                }
            }, 10);
        });
    }
    async initEventController(adapter) {
        const emitter = this.emitter;
        window.addEventListener("message", (event) => {
            var _a, _b;
            if (!((_a = event.data) === null || _a === void 0 ? void 0 : _a.isTronLink)) {
                return;
            }
            const message = (_b = event.data) === null || _b === void 0 ? void 0 : _b.message;
            switch (message.action) {
                case "accountsChanged":
                    return emitter.emit("AddressChanged", message.data.address);
            }
        });
    }
    overrideTronLinkJsonNode(tronweb) {
        [
            tronweb.fullNode.instance,
            tronweb.eventServer.instance,
            tronweb.solidityNode.instance,
        ].forEach((axiosInstance) => {
            axiosInstance.interceptors.request.use((config) => {
                config.baseURL = Utils_1.unifiBlockchainProxyUrl(utils_1.Blockchains.Tron);
                return Promise.resolve(config);
            });
        });
    }
}
exports.TronLinkConnector = TronLinkConnector;
